import moment from 'moment';

import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import { Button, Form, Spinner } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";

import { DropdownInput, DropdownInputMultiple, TextInput } from '../../../shared/form/FormInput';
import { Validators } from '../../../shared/utils/Validators';
import { postApi, getApi } from '../../../shared/services/apiHelper';
import { assessmentList, departmentList, runAdd, userList, assessmentCycleList, programmeList } from '../../../shared/settings/apiConfig';

import './RunAssessmentsAdd.scss';
import { PASS_PERCENTAGE } from '../../../shared/settings/config';

const runType = [
    { id: 1, value: "Now" },
    { id: 2, value: "Later" }
];
const autoExpire = [
    { id: 1, value: "Yes" },
    { id: 0, value: "No" }
];

const shareaslinkType = [
    { id: 1, value: "Yes" },
    { id: 0, value: "No" }
];

export const RunAssessmentsAdd = (props) => {

    const loggedInUserData = useSelector((state) => { return state.user });

    const [runAssessmentFormData, setRunAssessmentFormData] = useState({
        runname: { value: '', error: '', valid: false, validators: [Validators.required()] },
        department: { value: '', error: '', valid: false, validators: [Validators.required()] },
        assessmentCycle: { value: '', error: '', valid: true, validators: [Validators.required()] },
        clientId: { value: [], error: '', valid: false, validators: [Validators.required()] },
        assessmentId: { value: [], error: '', valid: false, validators: [Validators.required()] },
        runType: { value: runType[0].id, error: '', valid: true, validators: [Validators.required()] },
        duration: { value: 15, error: '', valid: true, validators: [Validators.required()] },
        expiryDate: { value: '', error: '', valid: false, validators: [Validators.required()] },
        autoendexpiry: { value: autoExpire[0].id, error: '', valid: true, validators: [Validators.required()] },
        programmeId: { value: '', valid: false, error: '', validators: [Validators.required()] },
        batch: { value: '', valid: false, error: '', validators: [Validators.required()] },
        section: { value: '', valid: false, error: '', validators: [Validators.required()] },
        shareAsLink: { value: shareaslinkType[1].id, valid: true, error: '', validators: [Validators.required()] },
        passpercentage: { value: '', valid: PASS_PERCENTAGE ? false : true, error: '', validators: PASS_PERCENTAGE ? [Validators.required()] : [] }
    });
    const [formValid, setFormValid] = useState(false);

    const [isloading, setIsLoading] = useState(false);
    const [formLoading, setFormLoading] = useState(false);

    const [clientData, setClientData] = useState([]);
    const [assessmentData, setAssessmentData] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [assessmentCycle, setAssessmentCycle] = useState([]);
    const [yearOptions, setYearOptions] = useState([]);
    const [programList, setProgramList] = useState([]);
    const [minendDate, setminendDate] = useState(new Date())

    useEffect(() => {
        setIsLoading(true);
        Promise.all([getAssessmentList(), getDepartmentList(), getAssessmentCycle(), programListData()]).then(responses => {
            setAssessmentData(responses[0].map(elem => { return { id: elem.id, value: elem.assessmentname }; }));
            setDepartments(responses[1].map(elem => { return { id: elem.id, value: elem.title }; }));
            setAssessmentCycle(responses[2].map((elem) => { return { id: elem, value: elem }; }));
            setProgramList(responses[3].map((elem) => { return { id: elem.id, value: elem.programmename }; }));

            let departmentId = '';
            if (responses[1].length == 1) {
                departmentId = responses[1][0].id;
            }

            const startYear = 2000, currentYear = new Date().getFullYear(), years = [];

            for (let year = currentYear; year >= startYear; year--) {
                years.push({ value: year, option: year });
            }

            setYearOptions(years);

            setRunAssessmentFormData(prevState => {
                prevState.department.value = departmentId;
                prevState.department.valid = true;

                prevState.batch.value = currentYear;
                prevState.batch.valid = true;
                return { ...prevState };
            });

            setIsLoading(false);
        });
    }, []);

    useEffect(() => {

        if (runAssessmentFormData.department.valid && runAssessmentFormData.programmeId.valid && runAssessmentFormData.batch.valid && runAssessmentFormData.section.valid) {
            let filter = [
                {
                    field: "id",
                    value: loggedInUserData.id,
                    op: "!=",
                    join: "AND"
                },
                {
                    field: "roleid",
                    value: 5, // Getting only Assesse's
                    op: "=",
                    join: "AND"
                }
            ];

            filter.push({ field: "departmentid", value: runAssessmentFormData.department.value, op: "=", join: "AND" });
            filter.push({ field: "programmeid", value: runAssessmentFormData.programmeId.value, op: "=", join: "AND" });
            filter.push({ field: "batch", value: runAssessmentFormData.batch.value, op: "=", join: "AND" });
            filter.push({ field: "section", value: `*${runAssessmentFormData.section.value}*`, op: "LIKE", join: "AND" });

            let payload = {
                field: ["id", "firstname", "lastname", "programmeid", "section", "batch", "departmentid"],
                filter: filter
            };
            postApi(userList, payload).then(response => {
                setClientData(response?.data?.data?.map(elem => { return { id: elem.id, value: elem.firstname + ' ' + elem.lastname }; }));

                setRunAssessmentFormData(prevState => {
                    prevState.clientId.value = [];
                    prevState.clientId.valid = false;
                    return { ...prevState };
                });
            }).catch((error) => {
                console.log(error, "error")
            });
        }

        return () => { }
    }, [runAssessmentFormData.department, runAssessmentFormData.section, runAssessmentFormData.batch, runAssessmentFormData.programmeId])

    const getDepartmentList = () => {
        let payload = {
            filter: []
        }

        if (loggedInUserData.roleid == 4) {
            payload.filter.push({
                field: "id",
                value: loggedInUserData.departmentid,
                op: "=",
                join: "AND"
            });
        }
        return new Promise((resolve, reject) => {
            postApi(departmentList, payload).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    }

    const programListData = (id) => {
        let payload = {
            "filter": []
        }
        return new Promise((resolve, reject) => {
            postApi(programmeList, payload).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    }


    useEffect(() => {
        setFormValid(Validators.validateForm(runAssessmentFormData));
    }, [runAssessmentFormData]);

    const getAssessmentCycle = () => {
        return new Promise((resolve, reject) => {
            getApi(assessmentCycleList).then(response => {
                console.log(response.data.data)
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    }

    const getAssessmentList = () => {
        let payload = {
            field: ["id", "assessmentname"],
            filter: [
                {
                    field: 'scoreparameter',
                    value: 1,
                    op: '=',
                    join: 'AND'
                },
                {
                    field: 'islatestversion',
                    value: 1,
                    op: '=',
                    'join': 'AND'
                }
            ]
        }
        return new Promise((resolve, reject) => {
            postApi(assessmentList, payload).then(response => {
                resolve(response.data.data);
            }).catch(error => {
                reject(error);
            })
        })
    }
    useEffect(() => {
        let minDate = new Date()
        if (runAssessmentFormData.scheduleDate?.value && runAssessmentFormData.runType?.value == runType[1].id) {
            minDate = new Date(runAssessmentFormData.scheduleDate?.value)
        }
        minDate = new Date(minDate.setMinutes(minDate.getMinutes() + Number(runAssessmentFormData.duration?.value)))
        console.log(new Date(minDate),"min", new Date(runAssessmentFormData.scheduleDate?.value))
        setminendDate(new Date(minDate))
        if (runAssessmentFormData.expiryDate?.value != "" && minDate > runAssessmentFormData.expiryDate?.value) {
            setRunAssessmentFormData((prevState) => {
                return ({
                    ...prevState, expiryDate: {
                        ...prevState?.expiryDate,
                        error: "The end time must be greater than the duration from the start time."
                    }
                })
            })
        } else if (runAssessmentFormData.expiryDate?.error == "The end time must be greater than the duration from the start time.") {
            setRunAssessmentFormData((prevState) => {
                return ({
                    ...prevState, expiryDate: {
                        ...prevState?.expiryDate,
                        error: ""
                    }
                })
            })
        }
    }, [runAssessmentFormData.duration?.value, runAssessmentFormData.scheduleDate?.value, runAssessmentFormData.runType?.value])


    const onInputChange = (type, event, value) => {
        let formControl = { ...runAssessmentFormData };
        let inputValue = '';
        if (type == "department" || type == 'assessmentCycle' || type == "programmeId" || type == "scheduleDate" || type == "expiryDate") {
            inputValue = event;
        } else if (type == "clientId" || type == 'assessmentId') {
            inputValue = value;
        } else if (type == "runType") {
            inputValue = event.target.value;
            if (inputValue == runType[0].id) {
                delete formControl['scheduleDate']
            } else {
                formControl['scheduleDate'] = { value: '', error: '', valid: true, validators: [Validators.required()] }
            }
        } else {
            inputValue = event.target.value;
        }
        setRunAssessmentFormData(() => {
            return {
                ...formControl,
                [type]: Validators.validateFormControl(formControl[type], inputValue)
            }
        });
    };

    const onClearInput = (type) => {
        onInputChange(type, null, []);
    }

    const filterPassedTime = (time) => {
        const currentDate = new Date();
        const selectedDate = new Date(time);

        return currentDate.getTime() < selectedDate.getTime();
    };

    const filterPassedEndTime = (time) => {
        const currentDate = minendDate
        const selectedDate = new Date(time);

        return currentDate.getTime() < selectedDate.getTime();
    };

    const saveRunAssessment = () => {
        setFormLoading(true);
        let data = {
            "runname": runAssessmentFormData.runname.value,
            "clientid": runAssessmentFormData.clientId.value,
            "departmentid": Number(runAssessmentFormData.department.value),
            "assessmentid": runAssessmentFormData.assessmentId.value,
            "runtype": runAssessmentFormData.runType.value,
            "expirydate": moment(runAssessmentFormData.expiryDate.value).utc().format("YYYY-MM-DD HH:mm:ss"),
            "programmeid": Number(runAssessmentFormData.programmeId.value),
            "duration": Number(runAssessmentFormData.duration.value),
            "autoendexpiry": Number(runAssessmentFormData.autoendexpiry.value),
            "batch": runAssessmentFormData.batch.value,
            "section": runAssessmentFormData.section.value,
            "assessmentcycle": runAssessmentFormData.assessmentCycle.value,
            "shareaslink": runAssessmentFormData.shareAsLink.value,
            "passpercentage": runAssessmentFormData.passpercentage.value
        };

        if (data['runtype'] == runType[0].id) {
            data['rundate'] = moment.utc().format("YYYY-MM-DD HH:mm:ss");
        } else {
            data['scheduleddate'] = moment.utc(runAssessmentFormData?.scheduleDate?.value).format("YYYY-MM-DD HH:mm:ss")
        }

        postApi(runAdd, { data }).then(response => {
            setFormLoading(false);
            props.history.goBack();
        }).catch((error) => {
            console.log(error);
            setFormLoading(false);
        });
    }

    const cancelRunAssessment = () => {
        props.history.goBack();
    }

    return (
        <div className="run-assessment-container w-100" >
            <img style={{ zIndex: -5, position: "absolute" }} class="w-80" height={"85%"} src={`${process.env.PUBLIC_URL}/static/images/assesseebg.jpg`} alt="bg" />

            <div className=' scontainer h-100 d-flex  align-items-center justify-content-center'>
                {
                    isloading ?
                        <div className='d-flex  align-items-center justify-content-center'>
                            <img className='run-loader-img' src={`${process.env.PUBLIC_URL}/static/images/loader.svg`} alt="loader-icon" />
                        </div> :
                        <div class="d-flex flex-column gap-3 shadow p-5 rounded assessment-box bg-white">
                            <div>* All fields are mandatory</div>
                            {/** Run Name Input */}
                            <div className='row-view gap-2'>
                                <Form.Label className='run-assesse-label required'>Assessment Name<span className="text-danger">*</span></Form.Label>
                                <div className='assessment-row'>
                                    <TextInput className={"p-2"} name={'runname'} placeholder={'Assessment Name'} value={runAssessmentFormData?.runname?.value}
                                        onChange={(event) => onInputChange('runname', event)} ignoreDefaultErrorSpace />
                                    <span className='text-danger'>
                                        {
                                            runAssessmentFormData.runname.error && runAssessmentFormData.runname.error.length ? <small className="error">{runAssessmentFormData.runname.error}</small> : null
                                        }
                                    </span>
                                </div>
                            </div>

                            {/** Assessment Dropdown */}
                            <div className='row-view gap-2'>
                                <Form.Label className='run-assesse-label'>Assessment <span className="text-danger">*</span></Form.Label>
                                <div className='assessment-row'>
                                    <DropdownInputMultiple showSelectAll name={'assessment'} value={runAssessmentFormData.assessmentId.value} placeholder="Select Assessment" data={assessmentData} onChange={(data) => { onInputChange('assessmentId', null, data); }} />
                                    <span>
                                        {
                                            assessmentData.length == 0 ? <span className='text-s text-info'>No assessment(s) available</span> : null
                                        }
                                    </span>
                                    <span className='text-danger'>
                                        {
                                            runAssessmentFormData.assessmentId.error && runAssessmentFormData.assessmentId.error.length ? <small className="error">{runAssessmentFormData.assessmentId.error}</small> : null
                                        }
                                    </span>
                                </div>
                            </div>

                            {/** Pass Percentage Input */}
                            {   
                                PASS_PERCENTAGE ? <div className='row-view gap-2'>
                                    <Form.Label className='run-assesse-label required'>Pass Percentage<span className="text-danger">*</span></Form.Label>
                                    <div className='assessment-row'>
                                        <TextInput className={"p-2"} name={'passpercentage'} placeholder={'Pass Percentage'} value={runAssessmentFormData?.passpercentage?.value}
                                            type="number" min="0" onChange={(event) => onInputChange('passpercentage', event)} onWheel={(event) => event.currentTarget.blur()} ignoreDefaultErrorSpace />
                                        <span className='text-danger'>
                                            {
                                                runAssessmentFormData.passpercentage.error && runAssessmentFormData.passpercentage.error.length ? <small className="error">{runAssessmentFormData.passpercentage.error}</small> : null
                                            }
                                        </span>
                                    </div>
                                </div> 
                            : ''}

                            {/** Assessment Cycle */}
                            <div className='row-view gap-2'>
                                <Form.Label className='run-assesse-label'>Assessment Cycle <span className="text-danger">*</span></Form.Label>
                                <div className='assessment-row'>

                                    <DropdownInput size={"md"} name='assessmentCycle' defaultValue="assessmentCycle" value={runAssessmentFormData.assessmentCycle.value} options={assessmentCycle} onChange={(value) => onInputChange('assessmentCycle', value)}
                                        error={runAssessmentFormData.assessmentCycle?.error} />
                                </div>
                            </div>

                            {/** Duration */}
                            <div className='row-view' style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <Form.Label className='run-assesse-label required'>
                                    Assessment Duration
                                </Form.Label>
                                <div className='duration' style={{ position: "relative", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <span className=' text-s' style={{ position: "absolute", top: "-20px", }}>
                                        {runAssessmentFormData.duration.value} mins
                                    </span>

                                    <input
                                        type="range"
                                        min="15"
                                        max="180"
                                        step="15"
                                        value={runAssessmentFormData.duration.value}
                                        className='duration-range'
                                        onChange={(event) => { onInputChange('duration', event); }}
                                        style={{ background: `linear-gradient(to right, blue ${((runAssessmentFormData.duration.value - 15) / (180 - 15)) * 100}%, #ddd ${((runAssessmentFormData.duration.value - 15) / (180 - 15)) * 100}%)` }}
                                    />
                                </div>
                            </div>

                            {/** Auto end expiry */}
                            <div className='row-view gap-2'>
                                <Form.Label className='run-assesse-label'>Auto End at Expiry of time <span className="text-danger">*</span></Form.Label>
                                <div className='assessment-row'>
                                    <Form className='run-type-controls'>
                                        {
                                            autoExpire.map((elem, index) => (
                                                <Form.Check key={"autoendexpiry-" + index} type="radio" name="autoendexpiry" id={"autoendexpiry-" + elem.id} value={elem.id} label={elem.value} defaultChecked={runAssessmentFormData.autoendexpiry.value == elem.id} error={runAssessmentFormData.autoendexpiry.error} onChange={(event) => { onInputChange('autoendexpiry', event, elem) }} />
                                            ))
                                        }
                                    </Form>
                                </div>
                            </div>
                            
                            <hr style={{ margin: "0" }}></hr>

                            {/** Department Dropdown */}
                            <div className='row-view gap-2'>
                                <Form.Label className='run-assesse-label'>Department <span className="text-danger">*</span> </Form.Label>
                                <div className='assessment-row'>
                                    {/* <Form.Control as="select" id="department" name="department" value={runAssessmentFormData?.department?.value} error={runAssessmentFormData.department.error} onChange={(event) => onInputChange('department', event)} disabled={departments.length == 0 ? true : false}>
                                <option disabled={true} value={""}>Select Department</option>
                                {
                                    departments?.map((department, key) => <option key={key} id={department.id} value={department.id}>{department?.title}</option>)
                                }
                            </Form.Control> */}

                                    <DropdownInput size={"md"} name='Department' defaultValue="Department" value={runAssessmentFormData.department.value} options={departments} onChange={(value) => onInputChange('department', value)}
                                        error={runAssessmentFormData.department?.error} />
                                    <span>
                                        {
                                            departments.length == 0 ? <span className='text-s text-info'>No Department available</span> : null
                                        }
                                    </span>
                                </div>
                            </div>

                            {/** Programme Dropdown */}
                            <div className='row-view gap-2'>
                                <Form.Label className='run-assesse-label'>Programme <span className="text-danger">*</span></Form.Label>
                                <div className='assessment-row'>
                                    {/* <Form.Control as="select" id="programmeId" name="programmeId" value={runAssessmentFormData?.programmeId?.value} error={runAssessmentFormData.programmeId.error} onChange={(event) => onInputChange('programmeId', event)} disabled={departments.length == 0 ? true : false}>
                                <option disabled={true} value={""}>Select Programme</option>
                                {
                                    programList?.map((program, key) => <option key={key} id={program.id} value={program.id}>{`${program?.title}`}</option>)
                                }
                            </Form.Control> */}

                                    <DropdownInput size={"md"} name='programmeId' defaultValue="Programme" value={runAssessmentFormData.programmeId.value} options={programList} onChange={(value) => onInputChange('programmeId', value)}
                                        error={runAssessmentFormData.programmeId?.error} />
                                    <span>
                                        {
                                            programList.length == 0 ? <span className='text-s text-info'>No Programme available</span> : null
                                        }
                                    </span>
                                </div>
                            </div>

                            {/** Batch Dropdown and Section */}
                            <div className='row-view gap-2'>
                                <Form.Label className='run-assesse-label'>Batch <span className="text-danger">*</span> </Form.Label>
                                <div className='assessment-row d-flex gap-2'>
                                    <div className='' style={{ flex: '1' }}>
                                        <Form.Control as="select" id="batch" name="batch" value={runAssessmentFormData?.batch?.value} error={runAssessmentFormData.batch.error} onChange={(event) => onInputChange('batch', event)}>
                                            <option disabled={true} value={""}>Select Batch</option>
                                            {
                                                yearOptions?.map((year, key) => <option key={key} id={year.id} value={year.id}>{year?.value}</option>)
                                            }
                                        </Form.Control>
                                    </div>

                                    <div className='d-flex align-items-center gap-1' style={{ flex: '1' }}>
                                        <Form.Label className='fw-bold ml-3'>Section <span className="text-danger">*</span></Form.Label>
                                        <TextInput className={"w-100 p-2"} name={'section'} placeholder={'Section'} value={runAssessmentFormData?.section?.value}
                                            onChange={(event) => onInputChange('section', event)} ignoreDefaultErrorSpace />

                                    </div>
                                </div>
                            </div>

                            {/** Client Dropdown */}
                            <div className='row-view gap-2'>
                                <Form.Label className='run-assesse-label'>Assesse <span className="text-danger">*</span></Form.Label>
                                <div className='assessment-row'>
                                    <DropdownInputMultiple showSelectAll name={'client'} value={runAssessmentFormData.clientId.value} placeholder="Select Assesse" data={clientData} onChange={(data) => { onInputChange('clientId', null, data); }} />
                                    <span>
                                        {
                                            clientData.length == 0 ? <span className='text-s text-info'>No Assesse(s) available</span> : null
                                        }
                                    </span>
                                    <span className='text-danger'>
                                        {
                                            runAssessmentFormData.clientId.error && runAssessmentFormData.clientId.error.length ? <small className="error">{runAssessmentFormData.clientId.error}</small> : null
                                        }
                                    </span>
                                </div>
                            </div>

                            {/** Run Type */}
                            <div className='row-view gap-2'>
                                <Form.Label className='run-assesse-label'>Schedule Start <span className="text-danger">*</span></Form.Label>
                                <div className='assessment-row'>
                                    <Form className='run-type-controls'>
                                        {
                                            runType.map((elem, index) => (
                                                <Form.Check key={"runtype-" + index} type="radio" name="runtype" id={"runtype-" + elem.id} value={elem.id} label={elem.value} defaultChecked={runAssessmentFormData.runType.value == elem.id} error={runAssessmentFormData.runType.error} onChange={(event) => { onInputChange('runType', event, elem) }} />
                                            ))
                                        }
                                    </Form>
                                    <span className='text-danger'>
                                        {
                                            runAssessmentFormData.runType.error && runAssessmentFormData.runType.error.length ? <small className="error">{runAssessmentFormData.runType.error}</small> : null
                                        }
                                    </span>
                                </div>
                            </div>

                            {
                                runAssessmentFormData?.runType?.value == runType[0].id ?
                                    <div className='row-view gap-2'>
                                        <Form.Label className='run-assesse-label'>Assessment Start Date and Time</Form.Label>
                                        <div className='assessment-row'>Start's Now</div>
                                    </div> :
                                    <div className='row-view gap-2'>
                                        <Form.Label className='run-assesse-label'>Assessment Start Date and Time <span className="text-danger">*</span></Form.Label>
                                        <div className='assessment-row'>
                                            <DatePicker
                                                id='scheduleDate'
                                                name='scheduleDate'
                                                placeholderText="Select Schedule Date"
                                                icon="fa fa-calendar"
                                                showIcon
                                                showTimeSelect
                                                toggleCalendarOnIconClick
                                                dropdownMode="select"
                                                timeIntervals={15}
                                                dateFormat="MM/dd/yyyy hh:mm a"
                                                timeFormat="HH:mm:ss"
                                                selected={runAssessmentFormData.scheduleDate.value ? runAssessmentFormData.scheduleDate.value : ''}
                                                minDate={new Date()}
                                                filterTime={filterPassedTime}
                                                onChangeRaw={(event) => event.preventDefault()}
                                                onChange={(date) => onInputChange("scheduleDate", date)} />
                                            <span className='text-danger'>
                                                {
                                                    runAssessmentFormData.scheduleDate.error && runAssessmentFormData.scheduleDate.error.length ? <small className="error">{runAssessmentFormData.scheduleDate.error}</small> : null
                                                }
                                            </span>
                                        </div>
                                    </div>
                            }

                            <div className='row-view gap-2'>
                                <Form.Label className='run-assesse-label'>Schedule End <span className="text-danger">*</span></Form.Label>
                                <div className='assessment-row'>
                                    <DatePicker
                                        id='enddate'
                                        name='enddate'
                                        placeholderText="Select End Date"
                                        icon="fa fa-calendar"
                                        showIcon
                                        showTimeSelect
                                        toggleCalendarOnIconClick
                                        dropdownMode="select"
                                        timeIntervals={15}
                                        dateFormat="MM/dd/yyyy hh:mm a"
                                        timeFormat="HH:mm:ss"
                                        selected={runAssessmentFormData.expiryDate.value ? runAssessmentFormData.expiryDate.value : ''}
                                        filterTime={filterPassedEndTime}
                                        minDate={new Date(minendDate)}
                                        onChangeRaw={(event) => event.preventDefault()}
                                        onChange={(date) => onInputChange("expiryDate", date)} />
                                    <span className='text-danger'>
                                        {
                                            runAssessmentFormData.expiryDate.error && runAssessmentFormData.expiryDate.error.length ? <small className="error">{runAssessmentFormData.expiryDate.error}</small> : null
                                        }
                                    </span>
                                </div>
                            </div>

                            {/** Checkbox */}
                            <div className='row-view gap-2'>
                                <Form.Label className='run-assesse-label'>Share as link <span className="text-danger">*</span></Form.Label>
                                <div className='assessment-row'>
                                    <Form className='run-type-controls'>
                                        {
                                            shareaslinkType.map((elem, index) => (
                                                <Form.Check key={"shareAsLink-" + index} type="radio" name="shareAsLink" id={"shareAsLink-" + elem.id} value={elem.id} label={elem.value} defaultChecked={runAssessmentFormData.shareAsLink.value == elem.id} error={runAssessmentFormData.shareAsLink.error} onChange={(event) => { onInputChange('shareAsLink', event, elem) }} />
                                            ))
                                        }
                                    </Form>
                                    <span className='text-danger'>
                                        {
                                            runAssessmentFormData.shareAsLink.error && runAssessmentFormData.shareAsLink.error.length ? <small className="error">{runAssessmentFormData.shareAsLink.error}</small> : null
                                        }
                                    </span>
                                </div>
                            </div>

                            <div className=' justify-content-center gap-3 mt-5 btmbtn'>
                                <Button onClick={cancelRunAssessment}>Cancel</Button>
                                <Button className='d-flex' onClick={saveRunAssessment} disabled={!formValid}>Save {formLoading ? <Spinner className='ms-2' as="span" animation="border" role="status" aria-hidden="true" /> : ''}</Button>
                            </div>
                        </div>
                }
            </div>

        </div>
    )
}